import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import IconButton from '@mui/material/IconButton'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { cambiarPass } from '../../actions/auth'
import { createMessage } from '../../actions/messages'
import axios from '../../axiosConfig.js'
import { programaActivo } from '../../helpers/funciones'
import i18n from '../../lang/idiomas'
import DomiciliosEnvioModif from '../ecommerce/DomiciliosEnvioModif.js'
import PasswordController from './PasswordController'
import PasswordRequirements from './PasswordRequirements'
import SubscripcionesStock from './SubscripcionesStock.js'

const Cuenta = () => {
  const dispatch = useDispatch()

  const auth = useSelector(state => state.auth)
  const subscripciones = useSelector(state => state.auth.user.subscripciones)
  const menus = useSelector(state => state.portal.menus)
  // HTML del comercial asignado (lo genera el paquete pk_b2x_per_comasig vía LISA)
  const [htmlComercial, setHtmlComercial] = useState('')
  const token = useSelector(state => state.auth.token)
  const [pass, setPass] = useState('')
  const [nuevoPass, setNuevoPass] = useState('')
  const [reNuevoPass, setReNuevoPass] = useState('')
  const [subsOcultas, setSubsOcultas] = useState(true)
  const [errorIguales, setErrorIguales] = useState(false)
  const [errorIgualAnterior, setErrorIgualAnterior] = useState(false)
  const [errorVacios, setErrorVacios] = useState(false)
  const portal = useSelector(state => state.portal.portal)

  const [showPassword, setShowPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showReNewPassword, setShowReNewPassword] = useState(false)

  useEffect(() => {
    window.wookie()
  })

  useEffect(() => {
    axios
      .post('/st/micuenta', {}, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setHtmlComercial(res.data.html || ''))
      .catch(err => console.error(err))
  }, [token])

  const onSubmit = e => {
    e.preventDefault()

    const passwordRegex = PasswordController.createQuerySet(
      portal?.longitud_password || 8,
      portal?.obligar_mayusculas === 'S',
      portal?.obligar_numero === 'S',
      portal?.obligar_simbolo === 'S',
    )

    // Validaciones
    if (pass !== '' && nuevoPass !== '' && reNuevoPass !== '') {
      if (nuevoPass !== reNuevoPass) {
        // No coinciden
        dispatch(createMessage(i18n.t('usuarios.ucontnoi'), 'error'))
        setErrorIguales(true)
        setErrorIgualAnterior(false)
        setErrorVacios(false)
      } else if (pass === nuevoPass) {
        dispatch(createMessage(i18n.t('usuarios.upassain'), 'error'))
        setErrorIguales(false)
        setErrorIgualAnterior(true)
        setErrorVacios(false)
      } else if (!passwordRegex.test(nuevoPass) || !passwordRegex.test(reNuevoPass)) {
        // No cumple requisitos
        dispatch(createMessage(i18n.t('usuarios.unocumre'), 'error'))
        setErrorIguales(true)
        setErrorIgualAnterior(false)
        setErrorVacios(false)
      } else {
        // Se modifica password
        dispatch(cambiarPass(pass, nuevoPass))
        // Limpiamos campos
        setPass('')
        setNuevoPass('')
        setReNuevoPass('')
        setErrorIguales(false)
        setErrorIgualAnterior(false)
        setErrorVacios(false)
      }
    } else {
      dispatch(createMessage(i18n.t('usuarios.ucamnopv'), 'error'))
      // Campos vacios
      setErrorIguales(false)
      setErrorIgualAnterior(false)
      setErrorVacios(true)
    }
  }

  const verSubscripciones = () => setSubsOcultas(!subsOcultas)
  const { isAuthenticated, user } = auth
  const subsActivas = programaActivo(menus, 'articulos')

  return (
    <>
      <div id='tt-pageContent'>
        <div className='container-indent'>
          <div className='container container-fluid-custom-mobile-padding'>
            <h1 className='tt-title-subpages noborder'>{i18n.t('usuarios.umicuent')}</h1>
            <div className='tt-shopping-layout'>
              <div className='tt-wrapper'>
                <h3 className='tt-title'>{i18n.t('usuarios.umisdato')}</h3>
                <div className='tt-table-responsive'>
                  <table className='tt-table-shop-02'>
                    <tbody>
                      <tr>
                        <td>{i18n.t('usuarios.uusr')}</td>
                        <td>{isAuthenticated ? user.usuario_web : ''} </td>
                      </tr>
                      <tr>
                        <td>{i18n.t('usuarios.uemail')}</td>
                        <td>{isAuthenticated ? user.email_usuario_web : ''} </td>
                      </tr>
                      <tr>
                        <td>{i18n.t('usuarios.unombr')}</td>
                        <td>{isAuthenticated ? user.nombre : ''} </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {htmlComercial ? (
                <div className='tt-wrapper'>
                  <h3 className='tt-title'>{i18n.t('cuenta.tuscomer', 'Tus Comerciales')}</h3>
                  <div
                    className='cuenta-comerciales'
                    dangerouslySetInnerHTML={{ __html: htmlComercial }}
                  />
                </div>
              ) : null}
              <div className='tt-wrapper'>
                <DomiciliosEnvioModif />
              </div>
              <div className='tt-wrapper'>
                <h3 className='tt-title'>{i18n.t('usuarios.ucambcon')}</h3>
                <div className='tt-login-form'>
                  <div className='row justify-content-center'>
                    <div className='col-md-8 col-lg-6'>
                      <div className='tt-item'>
                        <div className='form-default'>
                          <form onSubmit={onSubmit}>
                            <div className='form-group'>
                              <label htmlFor='pass'>{i18n.t('usuarios.ucontact')}</label>
                              <div className='tt-required'>{i18n.t('usuarios.ucamobli')}</div>
                              <div style={{ position: 'relative' }}>
                                <input
                                  className={
                                    errorVacios || errorIgualAnterior
                                      ? 'form-control error'
                                      : 'form-control'
                                  }
                                  type={showPassword ? 'text' : 'password'}
                                  id='pass'
                                  name='pass'
                                  autoComplete='current-password'
                                  placeholder={i18n.t('usuarios.uconactm')}
                                  onChange={e => setPass(e.target.value)}
                                  value={pass}
                                  style={{ paddingRight: '45px' }}
                                  required
                                />
                                <IconButton
                                  onClick={() => setShowPassword(v => !v)}
                                  onMouseDown={e => e.preventDefault()}
                                  style={{
                                    position: 'absolute',
                                    right: 5,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                  }}>
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </div>
                            </div>
                            <div className='form-group'>
                              <label htmlFor='nuevoPass'>{i18n.t('usuarios.unuecont')}</label>
                              <div style={{ position: 'relative' }}>
                                <input
                                  className={
                                    errorIguales || errorVacios || errorIgualAnterior
                                      ? 'form-control error'
                                      : 'form-control'
                                  }
                                  type={showNewPassword ? 'text' : 'password'}
                                  id='nuevoPass'
                                  name='nuevoPass'
                                  autoComplete='current-password'
                                  onChange={e => setNuevoPass(e.target.value)}
                                  value={nuevoPass}
                                  style={{ paddingRight: '45px' }}
                                  placeholder={i18n.t('usuarios.unueconm')}
                                  required
                                />
                                <IconButton
                                  onClick={() => setShowNewPassword(v => !v)}
                                  onMouseDown={e => e.preventDefault()}
                                  style={{
                                    position: 'absolute',
                                    right: 5,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                  }}>
                                  {showNewPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </div>
                            </div>
                            <div className='form-group'>
                              <label htmlFor='reNuevoPass'>{i18n.t('usuarios.urepcont')}</label>
                              <div style={{ position: 'relative' }}>
                                <input
                                  className={
                                    errorIguales || errorVacios || errorIgualAnterior
                                      ? 'form-control error'
                                      : 'form-control'
                                  }
                                  type={showReNewPassword ? 'text' : 'password'}
                                  id='reNuevoPass'
                                  name='reNuevoPass'
                                  autoComplete='current-password'
                                  onChange={e => setReNuevoPass(e.target.value)}
                                  value={reNuevoPass}
                                  style={{ paddingRight: '45px' }}
                                  placeholder={i18n.t('usuarios.urecontm')}
                                  required
                                />
                                <IconButton
                                  onClick={() => setShowReNewPassword(v => !v)}
                                  onMouseDown={e => e.preventDefault()}
                                  style={{
                                    position: 'absolute',
                                    right: 5,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                  }}>
                                  {showReNewPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </div>
                            </div>
                            <PasswordRequirements />
                            <br />
                            <div className='row'>
                              <div className='col-auto'>
                                <div className='form-group'>
                                  <button
                                    className='btn btn-border'
                                    type='submit'>
                                    {i18n.t('usuarios.ucambiar')}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {subsActivas ? (
                <div className='tt-wrapper'>
                  <h3 className='tt-title'>{i18n.t('usuarios.missubs')}</h3>
                  <button
                    className='btn btn-border subscripciones'
                    disabled={
                      subscripciones?.lineas && subscripciones.lineas?.length > 0 ? false : true
                    }
                    onClick={e => {
                      e.preventDefault()
                      verSubscripciones()
                    }}>
                    {i18n.t('usuarios.gessubs')}
                  </button>
                  <div
                    id={isAuthenticated ? 'subscripciones-' + user.usuario_web : 'subscripciones'}
                    hidden={subsOcultas}>
                    <SubscripcionesStock origen={'tabla-subs'} />
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Cuenta
